import {
  formatDisplayDate,
  journalOutcomeLabel,
  journalTestModeLabel,
  journalTriggerLabel,
  sanitizeJournalMessage,
} from '../../materiels/materielDisplayMaps';

/**
 * Onglet Journal — libellés support, sans IDs techniques.
 */
export default function MaterielDrawerJournalTab({
  items = [],
  loading = false,
  error = null,
  onRetry,
}) {
  if (loading) {
    return (
      <div className="space-y-2 p-1">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-12 rounded bg-gray-100 animate-pulse" />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-md border border-red-200 bg-red-50 px-3 py-3 space-y-2">
        <p className="text-sm text-red-800">
          Impossible de charger le journal d&apos;appels cloud.
        </p>
        {typeof onRetry === 'function' ? (
          <button
            type="button"
            onClick={onRetry}
            className="text-xs font-medium text-red-900 underline"
          >
            Réessayer
          </button>
        ) : null}
      </div>
    );
  }

  const list = Array.isArray(items) ? items : [];
  if (list.length === 0) {
    return (
      <p className="text-sm text-gray-500">
        Aucun appel cloud enregistré pour ce matériel.
      </p>
    );
  }

  return (
    <ul className="divide-y divide-gray-100 max-h-64 overflow-y-auto">
      {list.map((row, idx) => {
        const ok = Boolean(row.success);
        const msg = sanitizeJournalMessage(row.message);
        const testLabel = journalTestModeLabel(row.testMode);
        const key = row.id || `j-${idx}`;
        return (
          <li key={key} className="py-2.5 space-y-1">
            <div className="flex flex-wrap items-center gap-2">
              <span
                className={`inline-flex px-2 py-0.5 rounded text-xs font-medium border ${
                  ok
                    ? 'bg-emerald-50 text-emerald-800 border-emerald-200'
                    : 'bg-red-50 text-red-800 border-red-200'
                }`}
              >
                {journalOutcomeLabel(ok)}
              </span>
              <span className="text-xs text-gray-700">
                {journalTriggerLabel(row.trigger)}
              </span>
              {testLabel ? (
                <span className="text-[11px] text-amber-800 bg-amber-50 border border-amber-200 px-1.5 py-0.5 rounded">
                  {testLabel}
                </span>
              ) : null}
              <span className="text-[11px] text-gray-400 ml-auto whitespace-nowrap">
                {formatDisplayDate(row.createdAt)}
              </span>
            </div>
            {msg ? (
              <p className="text-xs text-gray-600 leading-relaxed">{msg}</p>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
